const state = {
  banner: [],
  banner_id: [],
};

export default state;
